import { formatCurrency, formatDate } from "../../../helpers/helpers";
import { GLOBAL_CONSTANTS } from "../../../constants/constants";
import CustomButton from "../../../components/CustomButton/Button";

export const getSettlementColumns = ({ onAssign }) => {
  return [
    {
      title: "UTR Number",
      dataIndex: "utr",
      key: "utr",
      render: (text) => text || GLOBAL_CONSTANTS.NA,
    },
    {
      title: "Business Name",
      dataIndex: "orgName",
      key: "orgName",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => formatCurrency(amount),
    },
    {
      title: "Credited Date",
      dataIndex: "txnDate",
      key: "txnDate",
      width: 200,
      render: (date) => formatDate(date),
    },
    {
      title: "Transaction Remarks",
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <CustomButton
          color="primary"
          variant="solid"
          onClick={() => onAssign(record.txnId)}
        >
          Assign Deal ID
        </CustomButton>
      ),
    },
  ];
};
